<div class="tabs-wrapper">
  <rt-tabs>
    @for (tab of slackIntegrations; track trackByIntegration($index, tab)) {
      <rt-tab
        [disabled]="actionsDisabled"
        (click)="selectSlackIntegration(tab)"
        [class.current]="slackIntegration === tab"
      >
        {{ tab.channelName }}
      </rt-tab>
    }
    <rt-tab (click)="addChannel()">
      {{ 'app.settings.integrations.slack.add_channel' | translate }}
    </rt-tab>
  </rt-tabs>
</div>

@if (slackIntegration) {
  <div class="activity-subscriptions-wrapper">
    <rt-activity-subscriptions-follow-offer
      [types]="[ActivitySubscriptionType.Slack]"
      [activitySubscriptions]="slackIntegration.activitySubscriptions"
      [hasOverdueCandidates]="false"
      [abilities]="abilities"
      [hasRequisitions]="hasRequisitions"
      (changeEvents)="changeEvents($event)"
    />
    <rt-divider variant="medium" />
    <rt-activity-subscriptions-followed-by-me-offer
      [types]="[ActivitySubscriptionType.Slack]"
      [activitySubscriptions]="slackIntegration.activitySubscriptions"
      [hasOverdueCandidates]="false"
      [abilities]="abilities"
      [hasRequisitions]="hasRequisitions"
      (changeEvents)="changeEvents($event)"
    />
    <rt-divider variant="medium" />
    <rt-activity-subscriptions-company
      [types]="[ActivitySubscriptionType.Slack]"
      [activitySubscriptions]="slackIntegration.activitySubscriptions"
      [abilities]="abilities"
      [hasRequisitions]="hasRequisitions"
      (changeEvents)="changeEvents($event)"
    />
    <div layout-horizontal margin-top>
      <rt-button
        [disabled]="actionsDisabled"
        (click)="deleteSlackIntegration(slackIntegration)"
        variant="plain"
        class="danger-on-hover"
      >
        <span>{{ 'app.settings.integrations.slack.remove' | translate }}</span>
        <rt-icon name="remove-circle" />
      </rt-button>
    </div>
  </div>
}
